<template>
    <v-row v-if="order">
        <v-col cols="12" class="pt-2 pb-0">
            <div v-if="order" class="my-2">
                <span class="font-weight-light">{{ sellerName }}</span>
            </div>
            <v-row v-if="products" v-for="product in products" :key="product.id" class="my-1" :class="['pl-3']">
                <v-col cols="6" class="text-truncate font-weight-medium pl-2 py-0">
                    {{ product.name }}
                </v-col>
                <v-col cols="2" class="pa-0">
                    {{ product.quantity ||  '---' }}
                </v-col>
                <v-col cols="4" class="pr-6 py-0 text-right">
                    {{ product.price ?  `${priceString(product.price)} ${currency.cyrName.toLowerCase()}` : '---' }} <br v-if="product.price">
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="4" class="px-0 py-1 text-uppercase">{{ $t('toPay') }}:</v-col>
                <v-col cols="8" class="py-1 text-right d-flex justify-end flex-wrap font-weight-bold">
                    <div>
                        <span :class="['subtitle-2', priceCss]" v-if="totalPrice">{{ `${priceString(totalPrice.toFixed(2))} ${currency.cyrName.toLowerCase()}` }}</span>
                    </div>
                    <div class="d-flex">
                        <div class="font-weight-bold subtitle-2 pr-2" v-if="discountPrice">
                            {{ `${priceString(discountPrice.toFixed(2))} ${currency.cyrName.toLowerCase()}` }}
                        </div>
                        <div class="teal--text font-weight-bold subtitle-2" v-if="totalDiscount">
                            {{ `(${$t('discount')} ${totalDiscount}%)` }}
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "OrderAmountRow",
    props:['order'],
    mixins: [],
    data() {
        return {
            isLoading: false,
            products: [],
            totalPrice: null,
            totalDiscount: null,
            discountPrice: null,
        }
    },
    computed: {
        currency() {
            return this.$store.getters.currencies.find(item => item.id === 1)
        },
        sellerName() {
            if(!this.order || !this.order.seller) return null;

            return this.order.seller.companyName || `${this.order.seller.firstName} ${this.order.seller.lastName}`;
        },
        orderInProcess() {
            return this.$store.state.order.inProcess.find(item => item.sellerID === this.order.seller.id);
        },
        orderProducts() {
            return this.$store.state.order.products;
        },
        orderTotalPrice() {
            return this.orderInProcess ? this.orderInProcess.priceSummary : null;
        },
        orderTotalDiscount() {
            return this.orderInProcess ? this.orderInProcess.totalDiscount : null;
        },
        priceCss() {
            return this.totalDiscount ? 'text-decoration-line-through' : '';
        },
    },
    methods: {
        setProducts() {
            if(this.isLoading) return false;

            this.products = [];
            const products = [];

            this.isLoading = true;

            if(!this.orderInProcess) return this.resetProducts();

            const productsData = this.orderProducts.find(item => item.seller.id === this.order.seller.id);
            const orderProducts = this.orderInProcess.products;

            productsData.data.forEach(item => {
                const data = {};
                const orderProduct = orderProducts.find(product => product.id === item.id);


                data['id'] = item.id;
                data['name'] = item.productName;
                data['quantity'] = orderProduct ? this.getQuantity(item, orderProduct) : null;
                data['price'] = orderProduct ? this.getPrice(orderProduct).toFixed(2) : null;

                products.push(data);
            });
            this.products = products;
            this.isLoading = false;
            this.setDiscounts();
        },
        setDiscounts() {
            this.totalPrice = this.orderTotalPrice;

            if(!this.orderInProcess.totalDiscount) {
                this.totalDiscount = null;
                this.discountPrice = null;

                return false;
            }

            this.totalDiscount = this.orderInProcess.totalDiscount;
            this.discountPrice = this.orderTotalPrice * (1 - this.totalDiscount / 100);
        },
        getPrice(orderProduct) {
            if(!this.orderInProcess) return null;

            if(!this.orderInProcess.totalDiscount) return orderProduct.calculatedPrice;


            return orderProduct.calculatedPrice * (1 - this.orderInProcess.totalDiscount / 100);
        },
        getQuantity(productData, orderProduct) {
            if(!productData || !orderProduct) return null;

            const pack = productData.pack;
            let quantity = parseFloat(orderProduct.quantity);

            if(pack.minValue) quantity *= parseFloat(pack.minValue);
            if(pack.value) quantity *= parseFloat(pack.value);
            if(pack.unitName) quantity += ` ${pack.unitName}`;

            return quantity;
        },
        resetProducts() {
            this.products = [];

            if(!this.order || !this.order.data) return false;

            this.order.data.forEach(item => {
                const productData = {};
                productData['id'] = item.id;
                productData['name'] = item.productName;
                productData['quantity'] = null;
                productData['price'] = null;

                this.products.push(productData);
            });

            this.isLoading = false;
        },
        rowCss(quantity) {
            return quantity ? 'grey--text' : '';
        },
        priceString(price) {
            return price ? numberFormat(price, 2, '.', ' ') : 0;
        },
    },
    created() {
        this.setProducts();
    },
    watch: {
        orderTotalPrice() {
            this.setProducts()
        },
        orderTotalDiscount() {
            this.setProducts()
        }
    }
}
</script>

<style scoped>
    .text-decoration-line-through {
        text-decoration: line-through!important;;
    }
</style>
